import { setDisplayParam, selectTourById } from '../../../actions';

export function createStopTapHandler(getStopKey) {
  return (marker, dispatch, displayRef) => {
    marker.addEventListener('tap', (evt) => {
      evt.stopPropagation();
      const data = marker.getData();
      const stopKey = getStopKey(data);
      const routeId = data?.routeId;
      const current = displayRef?.current;
      const isAlreadyHighlighted =
        current?.highlightStop === stopKey && current?.selectedTour === routeId;

      if (isAlreadyHighlighted) {
        dispatch(setDisplayParam({ highlightStop: null }));
      } else {
        dispatch(selectTourById({ selectedTour: routeId, noMapMovement: true }));
        dispatch(setDisplayParam({ highlightStop: stopKey !== undefined ? stopKey : null }));
      }
    });
  };
}
